<template>
    <div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Название <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="name">
            <div class="form-alert-danger" v-show="showAlert === 'name'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Тип
            </div>
            <input type="text" class="cd-modal-text-input" v-model="type">
            <div class="form-alert-danger" v-show="showAlert === 'type'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Телефон <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="phone">
            <div class="form-alert-danger" v-show="showAlert === 'phone'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Описание
            </div>
            <input type="text" class="cd-modal-text-input" v-model="description">
            <div class="form-alert-danger" v-show="showAlert === 'description'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <SelectRegionCity :selectedCityID="selectedCityID"
                              @citySelected="citySelected"/>
        </div>
        <div class="modal-button" v-on:click="apply">
            Сохранить
        </div>
    </div>
</template>

<script>
import SelectRegionCity from "../SelectRegionCity";
import {http_request} from "../../../../httpConfig";

export default {
    name: "OrganizationDataEntryFields",
    components: {SelectRegionCity},
    props: {
        buttonName: {
            type: String,
            default: 'Нет названия'
        },
        dataOrganization: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {
            name: '',
            type: '',
            phone: '',
            description: '',
            necessaryFields: [
                'name',
                'phone'
            ],
            showAlert: '',
            selectedCityID: null
        }
    },
    methods: {
        citySelected(value) {
            this.selectedCityID = value;
        },
        checkNecessary(data) {
            for (let field in this.necessaryFields) {
                if (!data[this.necessaryFields[field]]) {
                    this.showAlert = this.necessaryFields[field]
                    return false
                }
            }
            this.showAlert = ''
            return true
        },
        apply() {
            let data = {
                name: this.name,
                type: this.type,
                phone: this.phone,
                description: this.description,
                city_id: this.selectedCityID
            };
            const checkResult = this.checkNecessary(data);
            if (checkResult) {
                this.$emit('apply', data);
            }
        }
    },
    mounted() {
        if (this.dataOrganization && this.dataOrganization.id) {
            http_request.post('/get_organization_with_city_info', {id: this.dataOrganization.id})
                .then((request) => {
                    console.log(request.data);
                    this.name = request.data.organization.name;
                    this.type = request.data.organization.type;
                    this.phone = request.data.organization.phone;
                    this.description = request.data.organization.description;
                    this.selectedCityID = request.data.organization.city_id;
                })
            .catch(e => {console.log(e);})
        }
    }
}
</script>

<style scoped>

</style>
